import axios from 'axios';

import qs from 'qs';

import { API_DEFAULT_URL } from '@constants/common/api.constants';

const executeSendRequest =
  (method: 'post' | 'patch' | 'put' | 'delete', apiURL?: string) =>
  async <T>(
    urlPath: string,
    body?: Record<string, unknown> | FormData,
    headers?: Record<string, string>,
  ) => {
    const url = `${apiURL || API_DEFAULT_URL}${urlPath}`;

    const { data } = await axios[method]<T>(url, body, {
      withCredentials: true,
      headers: headers || {},
    });
    return data;
  };

const executeGetRequest =
  (method: 'get' | 'delete', apiURL?: string, withCredentials = true) =>
  async <T>(
    urlPath: string,
    query?: Record<string, unknown> | null,
    headers?: Record<string, string>,
  ): Promise<T> => {
    let url = `${apiURL || API_DEFAULT_URL}${urlPath}`;
    if (query) {
      url += `?${qs.stringify(query, { encode: true, arrayFormat: 'brackets' })}`;
    }

    const { data } = await axios[method]<T>(url, {
      withCredentials,
      headers: headers || {},
    });
    return data;

    // try {
    //   const { data } = await axios[method]<T>(url, { withCredentials, headers: headers || {} });
    //   return data;
    // } catch (error) {
    //   // if (axios.isAxiosError(error)) {
    //   //   if (error.response && error.response.status === ErrorStatusCode.InternalServerError) {
    //   //     window.location.href = PATH_SERVER_ERROR;
    //   //   }
    //   // }
    //   throw error;
    // }
  };

export const post = executeSendRequest('post');
export const patch = executeSendRequest('patch');
export const put = executeSendRequest('put');
export const get = executeGetRequest('get');
export const del = executeGetRequest('delete');

export const getApiMethod = (apiUrl: string, withCredentials = true) =>
  executeGetRequest('get', apiUrl, withCredentials);

export const postApiMethod = (apiUrl: string) =>
  executeSendRequest('post', apiUrl);

axios.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error),
);
